import React, { useState, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col, Image } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { useDispatch, useSelector } from "react-redux";
import {
  listProducts,
  deleteProduct,
  createProduct,
} from "../actions/productActions";
import { PRODUCT_CREATE_RESET } from "../constants/productConstants";
import Navbar from "../components/Navbar";
import axios from "axios";
const URL =
  process.env.NODE_ENV === "production" ? '' : "http://localhost:3001";

const ProductListScreen = ({ history, match }) => {
  const [product, setProduct] = useState([]);
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;
  const productDelete = useSelector((state) => state.productDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = productDelete;
  const productCreate = useSelector((state) => state.productCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    product: createdProduct,
  } = productCreate;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    
    const fetchgenSetData = async () => {
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      const { data } = await axios.get(URL + `/api/products`, config);
      setProduct(data);
    };
    fetchgenSetData();

    dispatch({ type: PRODUCT_CREATE_RESET });
    

    if (successCreate) {
      history.push(`/admin/product/${createdProduct._id}/edit`);
    } else {
      dispatch(listProducts());
    }
  }, [
    match,
    dispatch,
    history,
    userInfo,
    successDelete,
    successCreate,
    createdProduct,
  ]);

  const exploreHandler = (id) => {
    if (product) {
      history.push(`/product/${id}`);
    }
  };
  const deleteHandler = (id) => {
    if (window.confirm("Are your sure?")) {
      dispatch(deleteProduct(id));
    }
  };

  const handleResetGenset = async (id) => {
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.get(URL + `/api/products/reset/${id}`, config);
  }
  // const createProductHandler = () => {
  //   // dispatch(createProduct());
  //   history.push("/admin/product/create");
  // };

  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className="tw-mx-6">
        <Row className="align-items-center">
          <Col>
            <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-my-4">
              Genset Details
            </h3>
            <h5 className="tw-font-nunito tw-text-xl tw-font-semibold">
              Total Genset: {product && product.length}
            </h5>
            <br />
          </Col>
          {/* <Col className="text-right">
            <Button className="my-3" onClick={createProductHandler}>
              Create Product
            </Button>
          </Col> */}
        </Row>
        {loadingDelete && <Loader />}
        {errorDelete && <Message variant="danger">{errorDelete}</Message>}
        {loadingCreate && <Loader />}
        {errorCreate && <Message variant="danger">{errorCreate}</Message>}
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <Table
            striped
            bordered
            hover
            responsive
            className="table-sm tw-text-center tw-font-nunito myTable"
          >
            <thead
              className="tw-text-center tw-text-gray-100"
              style={{ backgroundColor: "#4a372e" }}
            >
              <tr>
                <th>GENSET ID</th>
                <th>STATUS</th>
                <th>DUE DATE</th>
                <th>EXPLORE</th>
                <th>UPDATE</th>
              </tr>
            </thead>
            <tbody className="tw-text-center">
              {products.map((product) => (
                <tr key={product._id}>
                  <td>{product.gensetNumber}</td>
                  <td>{product.getsetStatus}</td>
                  <td>{new Date(product.servicedueDate).toDateString()}</td>
                  <td>
                    <Button
                      variant="success"
                      className="btn-sm"
                      onClick={() => exploreHandler(product._id)}
                    >
                      View
                    </Button>
                  </td>
                  <td>
                    <LinkContainer
                      to={`/admin/product/${product._id}/edit`}
                      className="tw-mx-4 tw-cursor-pointer"
                    >
                      <i className="fas fa-edit"></i>
                    </LinkContainer>
                    <Button onClick={() => handleResetGenset(product._id)} variant="info" style={{marginRight: "10px"}} className="btn-sm">
                      <i class="fas fa-undo" aria-hidden="true"></i>
                    </Button>
                    {(userInfo.role === "MAIN_ADMIN") && (
                      <Button
                        variant="danger"
                        className="btn-sm"
                        onClick={() => deleteHandler(product._id)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default ProductListScreen;
